<template>
  <div class="row mt-20">
    <div class="w-100 container">
      <h3 class="font-size-56 mt-16 mb-24">Also Explore</h3>
    </div>
    <div class="d-flex flex-md-wrap additional-resources-section">
      <div v-for="(item, index) in content" :key="index" class="w-100 col col-md-6 d-flex flex-column flex-start">
        <div class="w-100">
          <img class="position-relative" :src="imagesUrl + item.imgUrl">
          <div class="overlay-text position-absolute pl-16 pt-0">
            <div class="title-max-width-440 font-size-32">
              {{ item.title }}
            </div>
          </div>
        </div>
        <div class="pt-10 w-568 mb-16">
          {{ item.body }}
        </div>
        <a class="btn my-8 btn-default btn-lg mt-auto mb-24" :href="item.buttonUrl">
          {{ item.button }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AlsoExplore',
  data() {
    return {
      imagesUrl: jsConfig.links.imagesUrl,
      content: jsConfig.alsoExplore,
    };
  }
};
</script>
